
  export const taskFields = [
    {name: "Name",             key: "name",             type: "text" },
    {name: "Description",      key: "description",      type: "text" },
    {name: "Notes",            key: "notes",            type: "text" },
    {name: "Assigned To",      key: "assignedEmail",    type: "text", isSortField: true },
    {name: "Priority",         key: "priority",         type: "number" },
    {name: "Cost",             key: "cost",             type: "number", step: "any" },
    // {name: "Rank",            key: "rank",             type: "number" },
    {name: "Due (counter)",    key: "dueCounter",       type: "number" },
    {name: "Counter Based On", key: "itemCounterId",    type: "select" },
    {name: "Due (Date)",       key: "dueDate",          type: "date" },
    {name: "Counter Interval", key: "counterInterval",  type: "number" },
    {name: "Interval",         key: "daysInterval",     type: "interval", monthsKey: "monthsInterval" },
    // item: Item @connection(fields: ["itemId"])
  ];


